/**
* @summary - Component that Provides Create Hospital Information Page
* @author Yuvasri S
* @since 2024-07-04
*/
import React, { useState, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import HospitalInformationContent from './HospitalInformationContent';
import EditHospitalInformationContent from './EditHospitalInformationContent';
import FacilityDetailsContent from './FacilityDetailsContent';
import AdditionalInfoContent from './AdditionalInfoContent';
import AttachmentsContent from './AttachmentsContent';
import TechnicalInfoContent from './TechnicalInfoContent';
import { useLocation } from 'react-router-dom';
import CustomDialog from '../commoncomponents/CustomDialog';
import { updateHospitalInformation, setMashospitaldetailsId } from '../../redux/reducers/HospitalInformationReducer/formSlice'; // Import setMashospitaldetailsId
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../commoncomponents/PageTitle';
import { getAuthToken } from "../../utility/tokenUtility";
import { MasterGraph } from '../../utility/apiURLS';
import axios from "axios";


function CreateHospitalInformation() {
    const [tabValue, setTabValue] = useState('1');
    const [dialogOpen, setDialogOpen] = useState(false);
    const location = useLocation();
    const isEditMode = location.state?.isEditMode || false;
    const isViewMode = location.state?.isViewMode || false;
    const hospitalDetailsId = useSelector((state) => state.form?.mashospitaldetailsId || "");
    const dispatch = useDispatch();

    const [hospitalInformation, setHospitalInformation] = useState({
        hospitalid: '',
        hospitalcode: '',
        hospitalname: '',
        locationflag: '',
        hospitaltype: '',
        directorname: '',
        state: '',
        address: '',
        postcode: '',
        telephoneno: '',
        emailaddress: '',
        faxno: '',
        branchmanager: '',
        handphoneno: '',
        telephonenum: '',
        faxnum: '',
        hospitalGroupId: '',
        clsvorate: ''
    });

    const [facilityDetails, setFacilityDetails] = useState({
        primaryId: '',
        fmshos1: '',
        fmshos2: '',
        bemshos1: '',
        bemshos2: '',
        femshos1: '',
        femshos2: '',
        fmslo1: '',
        fmslo2: '',
        bemslo1: '',
        bemslo2: '',
        femslo1: '',
        femslo2: '',
        speciality: '',
        facilitiesoutside: '',
        nonhospitalfacilities: ''
    });

    const [additionalInfo, setAdditionalInfo] = useState({
        primaryId: '',
        landarea: '',
        clsarea: '',
        bedstrength: '',
        groundmaint: '',
        llssoilfactor: '',
        llsringgitfactor: ''
    });

    const [technicalInfo, setTechnicalInfo] = useState({
        hospitalgroup: '',
        region: '',
        databasename: '',
        servername: '',
        companyname: '',
        clsvorate: ''
    });

    useEffect(() => {
        const fetchHospitalDetails = async () => {
            if (location.state && tabValue === '1') {

                const {
                    facilityid,
                    facilitycode,
                    hospitalname,
                    mashospitalfacilitydetails,
                    mashospitaladdlinfos,
                    id,
                    state, stateid
                } = location.state;

                try {
                    const token = getAuthToken("id_token");
                    const config = {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    };

                    const response = await axios.get(`${MasterGraph}/api/GraphHospitalMaster/GetHospitalMasterByFacilityId/${facilityid}`, config);
                    const hospitalDetailsArray = response.data;
                    if (hospitalDetailsArray.length > 0) {
                        const hospitalDetails = hospitalDetailsArray[0];

                        let locationflag = {
                            value: hospitalDetails.mashospitallocationflag.locationFlag,
                            id: hospitalDetails.mashospitallocationflag.id,
                            label: hospitalDetails.mashospitallocationflag.locationFlag
                        };

                        let hospitaltype = {
                            value: hospitalDetails.mashospitaltype.hospType,
                            id: hospitalDetails.mashospitaltype.id,
                            label: hospitalDetails.mashospitaltype.hospType
                        };
                        let states = {
                            value: state,
                            id: stateid,
                            label: state
                        }



                        const hospitalCodeOptions = [{
                            id: facilityid,
                            value: hospitalname,
                            label: facilitycode
                        }];


                        const selectedHospitalCode = hospitalCodeOptions.find(option => option.label === facilitycode);

                        setHospitalInformation({
                            id: id || '',
                            hospitalcode: selectedHospitalCode || '',
                            hospitalname: hospitalname || '',
                            hospitalid: facilityid || '',
                            locationflag: locationflag || '',
                            hospitaltype: hospitaltype || '',
                            directorname: hospitalDetails.directorname || '',
                            state: states || '',
                            address: hospitalDetails.address || '',
                            postcode: hospitalDetails.postcode || '',
                            telephoneno: hospitalDetails.hosptelephoneno || '',
                            emailaddress: hospitalDetails.hospemail || '',
                            faxno: hospitalDetails.hospfaxno || '',
                            branchmanager: hospitalDetails.contbranchmgr || '',
                            handphoneno: hospitalDetails.conthandphno || '',
                            telephonenum: hospitalDetails.conttelephone || '',
                            faxnum: hospitalDetails.contfaxno || '',
                            hospitalGroupId: hospitalDetails.mashospitalgroupId || '',
                            clsvorate: hospitalDetails.clsvorate || '',
                        });

                        dispatch(setMashospitaldetailsId(location.state.id));

                        if (mashospitalfacilitydetails && mashospitalfacilitydetails.length > 0) {
                            const details = mashospitalfacilitydetails[0];

                            setFacilityDetails({
                                primaryId: details.id || '',
                                fmshos1: details.headoffms || '',
                                fmshos2: details.headoffms1 || '',
                                bemshos1: details.headofbems || '',
                                bemshos2: details.headofbems1 || '',
                                femshos1: details.headoffems || '',
                                femshos2: details.headoffems1 || '',
                                fmslo1: details.liaisonofficerfms || '',
                                fmslo2: details.liaisonofficerfms1 || '',
                                bemslo1: details.liaisonofficerbems || '',
                                bemslo2: details.liaisonofficerbems1 || '',
                                femslo1: details.liaisonofficerfems || '',
                                femslo2: details.liaisonofficerfems1 || '',
                                speciality: details.speciality || '',
                                facilitiesoutside: details.facilitiesoutside || '',
                                nonhospitalfacilities: details.nonhospitalfacilities || ''
                            });
                        }

                        if (mashospitaladdlinfos && mashospitaladdlinfos.length > 0) {
                            const addInfoDetails = mashospitaladdlinfos[0];

                            setAdditionalInfo({
                                primaryId: addInfoDetails.id || '',
                                landarea: addInfoDetails.landarea || '',
                                clsarea: addInfoDetails.cleansingarea || '',
                                bedstrength: addInfoDetails.bedstrength || '',
                                groundmaint: addInfoDetails.groundmaintarea || '',
                                llssoilfactor: addInfoDetails.llssoilfactor || '',
                                llsringgitfactor: addInfoDetails.llsringgitfactor || ''
                            });
                        }
                    } else {
                        console.error("No hospital details ");
                    }
                } catch (error) {
                    console.error('Error fetching hospital details:', error);
                }
            }
        };

        // Call the async function
        fetchHospitalDetails();
    }, [location.state, dispatch, tabValue]);


    const handleChange = (event, newValue) => {
        if (!isEditMode && !isViewMode && (!hospitalDetailsId || !hospitalInformation.hospitalid)) {
            setDialogOpen(true);
            return;
        }
        setTabValue(newValue);
    }

    const handleHospitalInfoChange = (updatedInfo) => {
        setHospitalInformation((prevInfo) => ({ ...prevInfo, ...updatedInfo }));
    };

    const handleFacilityDetailsChange = (updatedDetails) => {
        setFacilityDetails((prevDetails) => ({ ...prevDetails, ...updatedDetails }));
    };

    const handleAdditionalInfoChange = (updatedInfo) => {
        setAdditionalInfo((prevDetails) => ({ ...prevDetails, ...updatedInfo }));
    };
    const handleTechnicalInfoChange = (updatedInfo) => {
        setTechnicalInfo((prevDetails) => ({ ...prevDetails, ...updatedInfo }));
    }
    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const pageTitleProps = {
        isEdit: isEditMode,
        isView: isViewMode,
        editTitle: "Edit Hospital Information",
        viewTitle: "View Hospital Information",
        title: "Create Hospital Information"
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <PageTitle {...pageTitleProps} />
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="Hospital Information Tabs" variant="fullWidth">
                        <Tab label="Hospital Information" value="1" />
                        <Tab label="Facility Details" value="2" />
                        <Tab label="Additional Info" value="3" />
                        <Tab label="Attachments" value="4" />
                        <Tab label="Technical Info" value="5" />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    {isEditMode ? (
                        <EditHospitalInformationContent
                            hospitalInformation={hospitalInformation}
                            onHospitalInfoChange={handleHospitalInfoChange}
                            tabValue={tabValue}
                        />
                    ) : (
                        <HospitalInformationContent
                            hospitalInformation={hospitalInformation}
                            onHospitalInfoChange={handleHospitalInfoChange}
                            isViewMode={isViewMode}
                            tabValue={tabValue}
                        />
                    )}
                </TabPanel>
                <TabPanel value="2">
                    <FacilityDetailsContent
                        hospitalcode={hospitalInformation.hospitalcode.label}
                        hospitalname={hospitalInformation.hospitalname}
                        facilityDetails={facilityDetails}
                        hospitalInformation={hospitalInformation}
                        onUpdateFacilityDetails={handleFacilityDetailsChange}
                        isViewMode={isViewMode}
                        isEditMode={isEditMode}
                    />

                </TabPanel>
                <TabPanel value="3">
                    <AdditionalInfoContent
                        hospitalcode={hospitalInformation.hospitalcode.label}
                        hospitalname={hospitalInformation.hospitalname}
                        hospitalInformation={hospitalInformation}
                        additionalInfo={additionalInfo}
                        onUpdateAdditionalInfo={handleAdditionalInfoChange}
                        isViewMode={isViewMode}
                        isEditMode={isEditMode}
                    />
                </TabPanel>
                <TabPanel value="4">
                    <AttachmentsContent
                        hospitalcode={hospitalInformation.hospitalcode.label}
                        hospitalname={hospitalInformation.hospitalname}
                        hospitalid={hospitalInformation.hospitalcode.id}
                        isViewMode={isViewMode}
                        isEditMode={isEditMode}
                    />
                </TabPanel>
                <TabPanel value="5">
                    <TechnicalInfoContent
                        hospitalcode={hospitalInformation.hospitalcode.label}
                        hospitalname={hospitalInformation.hospitalname}
                        technicalInfo={technicalInfo}
                        onUpdateTechnicalInfo={handleTechnicalInfoChange}
                        hospitalid={hospitalInformation.hospitalid}
                        isViewMode={isViewMode}
                        isEditMode={isEditMode}
                    //mashospitalid={mashospitalid}
                    />
                </TabPanel>
            </TabContext>
            <CustomDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                content="Please fill out the hospital information first before proceeding to other tabs."
                confirmBtn="Ok"
                onConfirm={handleDialogClose}
            />
        </Box>
    );
}

export default CreateHospitalInformation;
